// index.tsx
import React, { useEffect, useState } from "react";
import { Pagination, Table } from "antd";
import { DatatableProps } from "../../data/interface";

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  scroll,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
  const [mobilePage, setMobilePage] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const userType = JSON.parse(sessionStorage.getItem("info") || "{}").type;
  const useCustomerCards = userType === "customer" && isMobile;
  const mobilePageSize = 8;
  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    setFilteredDataSource(dataSource);
    setMobilePage(1);
  }, [dataSource]);

  useEffect(() => {
    const media = window.matchMedia("(max-width: 767.98px)");
    const updateViewport = () => setIsMobile(media.matches);
    updateViewport();
    media.addEventListener("change", updateViewport);
    return () => media.removeEventListener("change", updateViewport);
  }, []);

  const getColumnValue = (record: any, dataIndex: any) => {
    if (Array.isArray(dataIndex)) {
      return dataIndex.reduce((value, key) => value?.[key], record);
    }
    return dataIndex ? record?.[dataIndex] : undefined;
  };

  const renderMobileValue = (column: any, record: any, index: number) => {
    const value = getColumnValue(record, column.dataIndex);
    return column.render ? column.render(value, record, index) : (value ?? "—");
  };

  const mobileRecords = filteredDataSource?.slice(
    (mobilePage - 1) * mobilePageSize,
    mobilePage * mobilePageSize
  );

  return (
    <>
      {!useCustomerCards && <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 col-md-6">
            <div
              className="dataTables_length"
              id="DataTables_Table_0_length"
            ></div>
          </div>
        </div>
      </div>}

      {useCustomerCards ? (
        <section className="customer-mobile-records" aria-label="Customer records">
          <div className="customer-mobile-records__summary">
            <div>
              <span className="customer-mobile-records__eyebrow">Your records</span>
              <strong>
                {filteredDataSource?.length || 0} {(filteredDataSource?.length || 0) === 1 ? "item" : "items"}
              </strong>
            </div>
            <span className="customer-mobile-records__summary-icon">
              <i className="ti ti-list-details" />
            </span>
          </div>

          <div className="customer-mobile-records__list">
            {mobileRecords?.map((record: any, recordIndex: number) => (
              <article className="customer-record-card" key={record.key ?? record.id ?? recordIndex}>
                <div className="customer-record-card__top">
                  <span className="customer-record-card__number">
                    {String((mobilePage - 1) * mobilePageSize + recordIndex + 1).padStart(2, "0")}
                  </span>
                  <span>Record details</span>
                </div>
                <div className="customer-record-card__fields">
                  {columns.map((column: any, columnIndex: number) => {
                    const label = typeof column.title === "string" ? column.title : `Detail ${columnIndex + 1}`;
                    const isAction = /action/i.test(label) || column.dataIndex === "actions";
                    return (
                      <div
                        className={`customer-record-card__field${isAction ? " customer-record-card__field--actions" : ""}`}
                        key={`${String(column.key ?? column.dataIndex ?? "detail")}-${columnIndex}`}
                      >
                        <span className="customer-record-card__label">{label}</span>
                        <div className="customer-record-card__value">
                          {renderMobileValue(column, record, recordIndex)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </article>
            ))}
          </div>

          {filteredDataSource?.length > mobilePageSize && (
            <Pagination
              className="customer-mobile-records__pagination"
              current={mobilePage}
              pageSize={mobilePageSize}
              total={filteredDataSource.length}
              showSizeChanger={false}
              onChange={setMobilePage}
            />
          )}
        </section>
      ) : !Selections ? (
        <Table
          className="table datanew dataTable no-footer"
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          scroll={scroll}
          pagination={{
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
        />
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              alignSelf: "flex-end",
              paddingRight: "20px",
              paddingBottom: "20px",
            }}
          >
            Total - {filteredDataSource?.length || 0}
          </div>
          <Table
            className="table datanew dataTable no-footer"
            columns={columns}
            rowHoverable={false}
            dataSource={filteredDataSource}
            scroll={scroll}
            pagination={{
              locale: { items_per_page: "" },
              nextIcon: <i className="ti ti-chevron-right" />,
              prevIcon: <i className="ti ti-chevron-left" />,
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total, range) =>
                `Showing ${range[0]} - ${range[1]} of ${total} entries`,
            }}
          />
        </div>
      )}
    </>
  );
};

export default Datatable;
